// initial state
import axiosApi from '../../axiosApi'

// initial state
const state = {
  giverInfo: {
    usersCount: 0,
    productsCount: 0,
    productRequestsCount: 0
  }
}

// getters
const getters = {
  getGiverInfo: (state) => {
    return state.giverInfo
  }
}

// actions
const actions = {
  getGiverInfo ({commit}, payload) {
    return axiosApi.get(`/getGiverInfo`).then(response => {
      if (response.data.giverInfo) {
        commit('SET_GIVER_INFO', response.data.giverInfo)
      }
    }).catch(e => {
      console.log(e)
    })
  },
  shareOnFB ({commit}, payload) {
    return axiosApi.get(`/product/shareOnFB/${payload}`).then(response => {
      return response.data
    }).catch(e => {
      console.log(e)
    })
  },
  setDefaultMetas ({commit}, payload) {
    return axiosApi.get(`/product/setDefaultMetas`).then(response => {
      return response.data
    }).catch(e => {
      console.log(e)
    })
  },
  list ({commit}, payload) {
    return axiosApi.get(`/products?${payload}`)
      .then(response => {
        return response
      })
      .catch(err => {
        return err
      })
  },
  getNeeds ({commit}, payload) {
    return axiosApi.get(`/products/getNeeds`)
      .then(response => {
        return response
      })
      .catch(err => {
        return err
      })
  },
  getFilteredNeeds ({commit}, payload) {
    return axiosApi.post(`/products/getFilteredNeeds`, payload)
      .then(response => {
        return response
      })
      .catch(err => {
        return err
      })
  },
  getSearchIndividualProducts ({commit}, payload) {
    if (payload.isLogged) {
      return axiosApi.get(`/products/getProductsNamesForLoggedUser?${payload.payload}`)
        .then(response => {
          return response.data.products
        })
        .catch(err => {
          return err
        })
    } else {
      return axiosApi.get(`/products/getProductsNamesForNotLoggedUser?${payload.payload}`)
        .then(response => {
          return response.data.products
        })
        .catch(err => {
          return err
        })
    }
  },
  gatAddresses ({commit}, payload) {
    return axiosApi.get(`/products/gatAddresses?${payload}`)
      .then(response => {
        return response.data.address
      })
      .catch(err => {
        return err
      })
  },
  getAddressTranslations ({commit}, payload) {
    if (payload.isLogged) {
      return axiosApi.post(`/products/getAddressesForLoggedUser`, payload)
        .then(response => {
          return response.data
        })
        .catch(err => {
          return err
        })
    } else {
      return axiosApi.post(`/products/getAddresses`, payload)
        .then(response => {
          return response.data
        })
        .catch(err => {
          return err
        })
    }
  },
  listWithFriends ({commit}, payload) {
    return axiosApi.get(`/products/listWithFriends?${payload}`)
      .then(response => {
        return response
      })
      .catch(err => {
        return err
      })
  },
  getProduct ({commit}, payload) {
    return axiosApi.get(`/product/getProduct/${payload}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        return err
      })
  },
  sendProductRequest ({commit}, payload) {
    return axiosApi.post(`/product/saveProductRequest`, {
      data: JSON.stringify(payload)
    })
      .then(response => {
        return response.data
      })
      .catch(err => {
        return err
      })
  },
  saveDonateCount ({commit}, payload) {
    return axiosApi.post(`/product/saveDonateCount`, payload).then(response => {
      return response.data
    }).catch(e => {
      console.log(e)
    })
  },
  getProductWithRequests ({commit}, payload) {
    return axiosApi.get(`/product/getProductWithRequests/${payload}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        return err
      })
  },
  getProductRequests ({commit}, payload) {
    return axiosApi.get(`/product/getProductRequestsByUserId`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        return err
      })
  },
  acceptRequest ({commit, state}, payload) {
    return axiosApi.post(`/product/acceptRequest`, {
      data: JSON.stringify(payload)
    }).then(response => {
      return response.data
    }).catch(e => {
      console.log(e)
    })
  },
  getProdRequests ({commit}, payload) {
    return axiosApi.post(`/product/getProdRequests`, {data: payload}).then(response => {
      return response.data
    }).catch(e => {
      console.log(e)
    })
  },
  reset ({commit}, payload) {
    return axiosApi.post(`/product/reset`, {data: payload}).then(response => {
      return response.data
    }).catch(e => {
      console.log(e)
    })
  },
  placeAnother ({commit}, payload) {
    return axiosApi.post(`/product/placeAnother`, payload).then(response => {
      return response.data
    }).catch(e => {
      console.log(e)
    })
  },

  getAddressSuggestions ({commit}, payload) {
    return axiosApi.get('/products/getAddressSuggestions', {
      params: {
        address: payload.address
      }
    })
      .then(response => {
        return response
      })
      .catch(err => { return err.response })
  },
  addToFavorite ({commit}, payload) {
    return axiosApi.post(`/product/addToFavorite`, {data: payload}).then(response => {
      return response.data
    }).catch(e => {
      console.log(e)
    })
  }
}

// mutations
const mutations = {
  SET_GIVER_INFO (state, payload) {
    state.giverInfo = payload
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/products.js